module.exports = __webpack_public_path__ + "31929dd211239d8840d95092615c4eef.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_1-768.webp
// module id = 570
// module chunks = 0